import { SegmentedControl, ToneSegment } from "./styles";
import { ToneSegmentOption, ToneSegmentsProps } from "./types";

export const ToneSegments = <TOption extends ToneSegmentOption>({
  groupLabel,
  options,
  selectedValue,
  disabled,
  onChange,
  toneByValue,
  labelByValue,
}: ToneSegmentsProps<TOption>) => (
  <SegmentedControl role="group" aria-label={groupLabel}>
    {options.map((option) => (
      <ToneSegment
        key={option.value}
        type="button"
        $active={option.value === selectedValue}
        $tone={toneByValue?.[option.value]}
        aria-pressed={option.value === selectedValue}
        disabled={disabled}
        onClick={() => onChange(option)}
      >
        {labelByValue?.[option.value] ?? option.label}
      </ToneSegment>
    ))}
  </SegmentedControl>
);
